<template>
  <div>
    <el-dialog class="dialog_box" :title="dialogType" :visible.sync="DialogVisible2" width="40%" :before-close='close'
      center>
      <div class="top">
        <span class="fz14 c6">报修空调选择：</span>
        <el-select v-model="query.type" clearable placeholder="请选择方式" style="width:160px" @change="getProjectList">
          <el-option v-for="(item,index) in searchType" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div v-show="query.type=='0'">
          <el-input v-model="query.deviceNumber" placeholder="空调编号" style="width:140px">
          </el-input>
        </div>
        <div v-show="query.type=='1'">
          <el-select v-model="query.projectId" clearable placeholder="项目" style="width:140px" @change="getTowerList">
            <el-option v-for="(item,index) in projectOption" :key="index" :label="item.projectName"
              :value="item.projectId">
            </el-option>
          </el-select>
          <el-select v-model="query.towerNum" clearable placeholder="楼号" style="width:80px" @change="getstairList">
            <el-option v-for="(item,index) in towerIdOption" :key="index" :label="item.towerNum" :value="item.towerNum">
            </el-option>
          </el-select>
          <el-select v-model="query.stairsNum" clearable placeholder="梯号" style="width:80px">
            <el-option v-for="(item,index) in elevatorIdOption" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" size="small" class="ml10" @click="add()">添加</el-button>
      </div>
      <div v-for="(item,index) in deviceList" :key='index'>
        <div class="title">
          <div class="left">项目名称：{{item.projectName}}</div>
          <div class="right">
            <div class="right_item">楼号：{{item.towerNumber}}</div>
            <div class="right_item">梯号：{{item.stairsNumber}}</div>
          </div>
        </div>
        <div class="wrapper">
          <span>报修原因：</span>
          <el-input type="textarea" v-model="item.repairReason"></el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer flex row vertical-center">
        <el-button class="button--cancel" size="small" @click="close">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDetailByDevNumber, projectList, towerList, stairList, getDeviceByStairsNum, maintenanceHandle } from '@/api/complexManage/mainManage.js';
export default {
  name: 'mainRepair',
  props: {
    DialogVisible2: {
      type: Boolean
    },
    dialogType: {
      type: String
    },
  },
  data() {
    return {
      query: {
        type: '',
        deviceNumber: '',
        projectId: '',
        towerNum: '',
        stairsNum: '',
      },
      searchType: [
        { label: '按空调编号选择', value: '0' },
        { label: '按项目选择', value: '1' }
      ],
      projectOption: [],
      towerIdOption: [],
      elevatorIdOption: [],
      form: {},
      deviceList: [],
      formLabelWidth: '110px',

    };
  },
  created() {
  },
  mounted() {
  },
  watch: {},
  computed: {},
  methods: {
    init() {
      this.query = {
        type: '',
        deviceNumber: '',
        projectId: '',
        towerNum: '',
        stairsNum: '',
      }
      this.form = new Object
    },
    // 查询项目列表
    getProjectList(val) {
      if (val == '1') {
        projectList().then(res => {
          if (res.data.code == 200) {
            this.projectOption = res.data.data
          }
        })
      }else{
        this.query.projectId = ''
        this.query.towerNum = ''
        this.query.stairsNum = ''
      }
    },
    // 根据项目id查询楼号列表
    getTowerList(projectId) {
      let val = this.projectOption.find((item) => {
        return item.projectId == projectId
      })
       this.query.towerNum = ''
      this.query.stairsNum = ''
      this.towerIdOption = []
      this.elevatorIdOption = []
      this.form = {
        projectId: val.projectId,
        projectName: val.projectName,
        province: val.province,
        city: val.city,
        area: val.area,
        address: val.address,
        deviceList: this.deviceList
      }
      let obj = { projectId: val.projectId }
      towerList(obj).then(res => {
        if (res.data.code == 200) {
          this.towerIdOption = res.data.data
        }
      })
    },
    // 根据楼号查询梯号列表
    getstairList(towerNum) {

      let val = this.towerIdOption.find((item) => {
        return item.towerNum == towerNum
      })
      this.query.stairsNum = ''
      this.elevatorIdOption = []
      let params = {
        projectId: val.projectId,
        towerNum: val.towerNum,
      }
      stairList(params).then(res => {
        this.elevatorIdOption = []
        if (res.data.code == 200) {
          for (let item of res.data.data) {
            let obj = {
              label: item.stairsNum,
              value: item.stairsNum
            }
            this.elevatorIdOption.push(obj)
          }
        }
      })
    },
    add() {
      let params = {}
       let val = this.projectOption.find((item) => {
        return item.projectId == this.query.projectId
      })
      if (this.query.type == '0') {
        getDetailByDevNumber({ deviceNumber: this.query.deviceNumber }).then(res => {
          if (res.data.code == 200) {
            if(JSON.stringify(res.data.data) != "{}"){
               let { deviceId, devNumber, towerNumber, stairsNumber,projectName, elevatorBrand, } = res.data.data
                let obj = { deviceId, devNumber, towerNumber, stairsNumber,projectName, elevatorBrand, repairReason: '' }
                this.form = {
                  projectId: res.data.data.projectId,
                  projectName: res.data.data.projectName,
                  province: res.data.data.province,
                  city: res.data.data.city,
                  area: res.data.data.area,
                  address: res.data.data.address
                }
                this.deviceList.push(obj)
            }else{
              this.$message.error(res.data.msg)
            }
           
          }
        })
      } else {
        let { towerNum, stairsNum } = this.query
        params = { projectId: this.form.projectId, towerNum, stairsNum }
        getDeviceByStairsNum(params).then(res => {
          if (res.data.code == 200) {
            let { deviceId, devNumber, towerNumber = this.query.towerNum,projectName=val.projectName ,stairsNumber = this.query.stairsNumber, elevatorBrand, } = res.data.data
            let obj = { deviceId, devNumber, towerNumber, stairsNumber, projectName,elevatorBrand, repairReason: '' }
            this.deviceList.push(obj)
          }
        })
      }

    },
    // 提交表单
    handleSubmit() {
      if(this.deviceList.length<1){
        this.$message.error("请先进行填报")
        return
      }
      this.form.deviceList = this.deviceList
      maintenanceHandle(this.form).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.msg)
          this.close()
        }
      })

    },
    close() {
      this.init();
      this.deviceList = []
      this.$emit('close2', false);
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog_box {
  color: #324170;
  .top {
    margin: 0 0 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .el-select {
      margin: 0 0.3rem;
    }
  }
  .title {
    background: rgba(1, 173, 168, 0.1);
    padding: 10px;
    display: flex;
    justify-content: space-between;
    .left {
    }
    .right {
      width: 40%;
      display: flex;
      justify-content: space-between;
      .right_item {
        width: 30%;
      }
    }
  }
  .wrapper {
    display: flex;
    margin: 20px 0;
    .el-textarea {
      flex: 1;
    }
  }
}
</style>